import MentorStatusChip from 'components/Chips/MentorStatusChip';
import getFilters from 'components/Filters';
import Input from 'components/form/Inputs/Input';
import MENTOR_STATUS from 'enums/MentorStatus';
import { FC, useContext } from 'react';
import useSWR from 'swr';
import MentorshipReferee from 'types/MentorshipReferee';
import { mentorTags } from 'utils/mentorTags';
import {
  considerationColumn,
  diplomaColumn,
  expertiseFieldsColumn,
  formationsColumn,
  getCareerPlanColumn,
  getEntrepreneurshipColumn,
  getJobSearchColumn,
  getStudiesColumn,
  hobbyColumn,
  wantedMentorshipsColumn,
} from 'utils/tagColumns';
import { getLocaleDate } from 'utils/time';
import { CustomTagColumnNames, MentorsContext, TagColumnNames } from '..';

const Filters = getFilters<TagColumnNames, CustomTagColumnNames>();
const MentorsFilters: FC = () => {
  const {
    search,
    setSearch,
    tags,
    setTags,
    take,
    setTake,
    customTags,
    setCustomTags,
  } = useContext(MentorsContext);

  const handleChangeCustomTags: React.ChangeEventHandler<HTMLInputElement> = (
    e,
  ) => {
    if (e.target.name === 'eventStartDate') {
      return setCustomTags({
        ...customTags,
        eventStartDate: e.target.value,
      });
    }
    console.log('azer');
  };

  const removeCustomTag = (tagName: CustomTagColumnNames) => {
    if (tagName === 'eventStartDate') {
      return setCustomTags({
        ...customTags,
        eventStartDate: '',
      });
    }
  };

  const { data: referees } = useSWR<MentorshipReferee[]>('/mentorship-referee');
  return (
    <Filters
      tagList={[
        {
          columnName: 'referee',
          columnTitle: 'Chargé de mentorat',
          tags:
            referees?.map((referee) => {
              return {
                name: referee.name || '',
                label: `(Chargé) ${referee.name}`,
                labelComponent: referee.name || '',
              };
            }) || [],
        },
        {
          columnName: 'status',
          columnTitle: 'Statut du mentorat',
          tags: mentorTags.map((tag) => ({
            name: tag,
            label: MENTOR_STATUS[tag],
            labelComponent: <MentorStatusChip status={tag} />,
          })),
        },
        getJobSearchColumn('mentor'),
        getCareerPlanColumn('mentor'),
        getStudiesColumn('mentor'),
        getEntrepreneurshipColumn('mentor'),
        expertiseFieldsColumn,
        formationsColumn,
        diplomaColumn,
        considerationColumn,
        hobbyColumn,
        wantedMentorshipsColumn,
      ]}
      customTags={[
        {
          columnName: 'eventStartDate',
          columnTitle: 'Date de formation',
          component: (
            <div style={{ padding: 1 }}>
              <Input
                type="date"
                value={customTags.eventStartDate}
                onChange={handleChangeCustomTags}
                name="eventStartDate"
              />
            </div>
          ),
          getDisplayText: (value: string) => getLocaleDate(value),
        },
      ]}
      state={{ tags, search, take, customTags }}
      removeCustomTag={removeCustomTag}
      setTags={setTags}
      setSearch={setSearch}
      setTake={setTake}
    />
  );
};

export default MentorsFilters;
